export default __webpack_public_path__ + "static/spiritual-maya-activity-4-ae23cdd0aa6e2f6df8688e109e0a8ceb.jpg";